import { AREA_CHART_X_AXIS_DEFAULT_PROPS } from '../../Chart'
import { BIRDVIEW_CHART_FLOW_SERIES } from '../DashboardBirdview.constants.charts'
import { formatBirdviewChartDate } from '../DashboardBirdview.utils.charts'

export function getBirdviewFlowSeries(t) {
  return BIRDVIEW_CHART_FLOW_SERIES.map(series => ({
    ...series,
    name: t(series.labelKey),
  }))
}

export function getBirdviewLineChartXAxisProps() {
  return {
    ...AREA_CHART_X_AXIS_DEFAULT_PROPS,
    tickFormatter: formatBirdviewChartDate,
  }
}
